<!--
 * @Author: Gaho
 * @Date: 2024-01-15 10:01:10
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-02 11:01:00
 * @Description: 针对mini版本移动端布局
-->
<template>
    <div class="bet-options">
        <div>
            <BetTargetOption 
                :isSubmiting="isSubmiting"
                :bet-target-model-value="betTargetModelValue"
                @update:bet-target-model-value="emit('update:betTargetModelValue', $event)"
            />
        </div>
        <div class="h-[85px] grid-cols-7">
            <!-- 下注金額選項 -->
            <CasinoBetOptionSectionAmountOption 
                :betTookit="betTookit" 
                :bet-amount-modal-value="betAmountModalValue"
                :sound="sound" 
                :is-submiting="isSubmiting" 
                class="col-span-4 amount rounded-[10px]"
                @update:bet-amount-modal-value="emit('update:betAmountModalValue', $event)" 
            />
            <div class="col-span-3 flex">
                <div class="mode-switch mr-2">
                    <ButtonGrayButton
                        :blue="!isAuto"
                        :fullWidth="true"
                        :disabled="isSubmiting"
                        @click="changeMode(false)"
                    >
                        {{ $t('Manaual') }}
                    </ButtonGrayButton>
                    <ButtonGrayButton
                        :blue="isAuto"
                        :fullWidth="true"
                        :disabled="isSubmiting"
                        @click="changeMode(true)"
                    >
                        {{ $t('Auto') }}
                    </ButtonGrayButton>
                </div>
                <ButtonBet 
                    v-if="!isAuto"
                    :is-submiting="isSubmiting"
                    :bet-submit="betSubmit"
                    @update:is-submiting="$emit('update:isSubmiting', $event)"
                    :expected-reward="expectedReward" 
                    class="rounded-[7px] limbo-bet-button"
                />
                <ButtonBetAuto 
                    v-else 
                    :isSubmiting="isSubmiting" 
                    :auto-bet-tool-kit="autoBetToolKit"
                    class="limbo-bet-button"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { useBettingToolkit } from '~/common/js/bettingToolkit';
import { useAutoBetToolKit } from '~/common/js/bettingToolkit/auto';

import BetTargetOption from './betTargetOption.vue';

const props = defineProps({
    betAmountModalValue: {// 投注金額
        type: Number,
        required: true
    },
    isSubmiting: {// 用於防止重複點擊,以及自動投注持續化條件
        type: Boolean,
        required: true
    },
    betSubmit: { // 投注方法
        type: Function as PropType<() => Promise<void>>,
        required: true
    },
    isAuto: {// 是否為自動
        type: Boolean,
        required: true
    },
    expectedReward: {// 預期獎勵
        type: Number,
        default: 0,
        required: false
    },
    sound: {
        type: Boolean,
        default: false,
        required: false
    },
    autoBetToolKit: { // 自動投注工具包
        type: Object as PropType<ReturnType<typeof useAutoBetToolKit>>,
        required: true
    },
    betTookit: { // 投注工具包
        type: Object as PropType<ReturnType<typeof useBettingToolkit>>,
        required: true
    },
    betTargetModelValue: {
        type: Number,
        required: true
    }
})
const emit = defineEmits([
    'stopAuto', 
    'update:betAmountModalValue', 
    'update:isSubmiting',
    'update:betTargetModelValue',
    'changeMode'
]);

const changeMode = (isAutoMode)=>{
    emit('changeMode', !!isAutoMode);
};
</script>
<style lang="scss" scoped>
.bet-options {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 16px;
    >div {
        &:nth-of-type(1){
            width: 100%;
        }
        &:nth-of-type(2){
            width: 100%;
            display: grid;
            column-gap: 8px;
        }
    }
    .mode-switch{
        flex: 0;
        & > button{
            height: calc(50% - 4px); 
            min-width: 40px;
            padding-left: 4px;
            padding-right: 4px;
            &:first-child{
                margin-bottom: 8px;
            }
        }
    }
    .limbo-bet-button {
        flex-grow: 1; 
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
}
</style>